import store from '@/store'

export default [
  {
    path: '/admin/visitation-route-plans',
    name: 'visitation-plan',
    meta: { requiresAuth: true },
    component: () => import('@/pages/customer/visitation')
  }
]